export function setCrews(state, crews) {
    state.crews = crews;
}

export function setCrew(state, crew) {
    state.crew = crew;
}

